import { Image, Box } from '@chakra-ui/react';
import dashboard from '../../../public/icons/dashboard.svg';
import dashboardActive from '../../../public/icons/dashboardActive.svg';
import connections from '../../../public/icons_v2/message.svg';
import connectionsActive from '../../../public/icons_v2/messageActive.svg';
import investors from '../../../public/icons_v2/profile-add.svg';
import investorsActive from '../../../public/icons_v2/profile-add-active.svg';
import dealFlow from '../../../public/icons_v2/deal-flow.svg';
import dealFlowActive from '../../../public/icons_v2/deal-flow-active.svg';
import startup from '../../../public/icons_v2/cup.svg';
import startupActive from '../../../public/icons_v2/cupActive.svg';
import experts from '../../../public/icons_v2/user-octagon.svg';
import expertsActive from '../../../public/icons_v2/user-octagon-active.svg';
import settings from '../../../public/icons_v2/setting.svg';
import settingsActive from '../../../public/icons_v2/settingActive.svg';
import { HUB_8020_AUTH_USER } from '../../../helpers/constant';
import users from '../../../public/icons/users.svg';
import creditCard from '../../../public/icons/creditCard.svg';
import creditCardActive from '../../../public/icons/creditCardActive.svg';

import { useEffect, useMemo, useState } from 'react';
import {
  MdDynamicFeed,
  MdReport,
  MdPersonSearch,
  MdPersonAdd,
  MdPersonAddAlt,
  MdEvent,
  MdOutlineBusinessCenter,
  MdBusinessCenter,
} from 'react-icons/md';
import { FaBusinessTime, FaMicrophone, FaMicrophoneAlt, FaNewspaper } from 'react-icons/fa';

const Navs = () => {
  const user = JSON.parse(localStorage.getItem(HUB_8020_AUTH_USER));
  const accountType = user?.userTypeTitle;
  const founderNav = useMemo(() => {
    return [
      {
        to: '/feed',
        name: 'Feed',
        tooltip: 'View and interact with posts from the community',
        icon: <MdDynamicFeed className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdDynamicFeed className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/dashboard',
        name: 'Dashboard',
        tooltip:
          'Connect with investors and experts, track your startup progress',
        icon: <Image h="22px" w="22px" src={dashboard} alt="dashboard-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dashboardActive} alt="dashboard-icon" />
        ),
      },
      {
        to: '/investors',
        name: 'Investors',
        tooltip: 'Discover and connect with potential investors',
        icon: <Image h="22px" w="22px" src={investors} alt="investors-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={investorsActive} alt="investors-icon" />
        ),
      },
      {
        to: '/experts',
        name: 'Experts',
        tooltip: 'Find industry experts and mentors for guidance',
        icon: <Image h="22px" w="22px" src={experts} alt="experts-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={expertsActive} alt="experts-icon" />
        ),
      },
      {
        to: '/connections',
        name: 'Connections',
        tooltip: 'Manage your professional network and relationships',
        icon: (
          <Image h="22px" w="22px" src={connections} alt="connections-icon" />
        ),
        activeIcon: (
          <Image
            h="22px"
            w="22px"
            src={connectionsActive}
            alt="connections-icon"
          />
        ),
      },
      {
        to: '/deal-flow',
        name: 'Raise Funds',
        tooltip: 'Begin the process of setting up a new fundraising round',
        icon: <Image h="22px" w="22px" src={dealFlow} alt="deal-flow-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dealFlowActive} alt="deal-flow-icon" />
        ),
      },
      {
        to: '/startup-offers',
        name: 'Startup Offers',
        tooltip: 'Browse exclusive offers and opportunities for startups',
        icon: <Image h="22px" w="22px" src={startup} alt="startup-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={startupActive} alt="startup-icon" />
        ),
      },
      {
        to: '/bookings',
        name: 'Bookings',
        tooltip: 'Schedule and manage meetings with investors and experts',
        icon: <Image h="22px" w="22px" src={investors} alt="investors-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={investorsActive} alt="investors-icon" />
        ),
      },
      {
        to: '/events',
        name: 'Events',
        tooltip: 'Discover and register for networking events',
        icon: <MdEvent className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdEvent className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/account-settings',
        name: 'Settings',
        tooltip: 'Manage your profile, preferences, and account settings',
        icon: <Image h="22px" w="22px" src={settings} alt="settings-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={settingsActive} alt="settings-icon" />
        ),
      },
    ];
  }, []);

  const expertNav = useMemo(() => {
    return [
      {
        to: '/feed',
        name: 'Feed',
        tooltip: 'View and interact with posts from the community',
        icon: <MdDynamicFeed className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdDynamicFeed className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/dashboard',
        name: 'Dashboard',
        tooltip: 'Overview of your expert profile and consultation requests',
        icon: <Image h="22px" w="22px" src={dashboard} alt="dashboard-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dashboardActive} alt="dashboard-icon" />
        ),
      },
      {
        to: '/founders',
        name: 'Founders',
        tooltip: 'Browse and connect with startup founders seeking guidance',
        icon: <Image h="22px" w="22px" src={investors} alt="founder-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={investorsActive} alt="founder-icon" />
        ),
      },
      {
        to: '/connections',
        name: 'Connections',
        tooltip: 'Manage your professional network and relationships',
        icon: (
          <Image h="22px" w="22px" src={connections} alt="connections-icon" />
        ),
        activeIcon: (
          <Image
            h="22px"
            w="22px"
            src={connectionsActive}
            alt="connections-icon"
          />
        ),
      },
      {
        to: '/events',
        name: 'Events',
        tooltip: 'Discover and register for networking events',
        icon: <MdEvent className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdEvent className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/account-settings',
        name: 'Settings',
        tooltip:
          'Manage your profile, consultation slots, and account settings',
        icon: <Image h="22px" w="22px" src={settings} alt="settings-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={settingsActive} alt="settings-icon" />
        ),
      },
    ];
  }, []);

  const adminNav = useMemo(() => {
    return [
      {
        to: '/dashboard',
        name: 'Dashboard',
        tooltip: 'Admin overview of platform metrics and activities',
        icon: <Image h="22px" w="22px" src={dashboard} alt="dashboard-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dashboardActive} alt="dashboard-icon" />
        ),
      },
      {
        to: '/users',
        name: 'Users',
        tooltip: 'Manage all platform users and their accounts',
        icon: <Image h="22px" w="22px" src={users} alt="all-users-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dashboardActive} alt="all-users-icon" />
        ),
      },
      {
        to: '/startup-offers',
        name: 'Startup Offers',
        tooltip: 'Manage startup offers and opportunities on the platform',
        icon: <Image h="22px" w="22px" src={startup} alt="startup-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={startupActive} alt="startup-icon" />
        ),
      },
      {
        to: '/brands',
        name: 'Brands',
        tooltip: 'Manage brand partnerships and collaborations',
        icon: <Image h="22px" w="22px" src={startup} alt="startup-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={startupActive} alt="startup-icon" />
        ),
      },
      {
        to: '/news',
        name: 'News',
        icon: <FaNewspaper className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <FaNewspaper className="h-[22px] w-[22px] text-white" />,
      },
      // {
      //   to: '/admin/subscriptions',
      //   name: 'Subscriptions',
      //   tooltip: 'Monitor and manage user subscription plans',
      //   icon: (
      //     <Image h="22px" w="22px" src={creditCard} alt="connections-icon" />
      //   ),
      //   activeIcon: (
      //     <Image h="22px" w="22px" src={creditCard} alt="connections-icon" />
      //   ),
      // },

      {
        to: '/admin/pitch-requests',
        name: 'Pitch Requests',
        tooltip: 'View pitch requests',
        icon: <FaMicrophone className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <FaMicrophoneAlt className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/admin/adverts',
        name: 'Adverts',
        tooltip: 'Manage platform advertisements and promotional content',
        icon: <Image h="22px" w="22px" src={experts} alt="experts-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={expertsActive} alt="experts-icon" />
        ),
      },
      {
        to: '/admin/deleted-users',
        name: 'Deleted Users',
        tooltip: 'View and manage deleted user accounts',
        icon: <Image h="22px" w="22px" src={experts} alt="experts-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={expertsActive} alt="experts-icon" />
        ),
      },
      {
        to: '/post-reports',
        name: 'Post Reports',
        tooltip: 'Review and manage reported posts and content',
        icon: <Image h="22px" w="22px" src={settings} alt="settings-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={settingsActive} alt="settings-icon" />
        ),
      },
      {
        to: '/profile-reports',
        name: 'Profile Reports',
        tooltip: 'Review and manage reported user profiles',
        icon: <MdPersonSearch className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdPersonSearch className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/admin/subadmins',
        name: 'Sub Admins',
        tooltip: 'Manage sub-administrator accounts and permissions',
        icon: <MdPersonAddAlt className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdPersonAdd className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/events',
        name: 'Events',
        tooltip: 'Manage platform events and networking opportunities',
        icon: <MdEvent className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdEvent className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/admin/deals',
        name: 'Deals',
        tooltip: 'Monitor and manage investment deals and transactions',
        icon: (
          <MdOutlineBusinessCenter className="h-[22px] w-[22px] text-gray-900" />
        ),
        activeIcon: (
          <MdBusinessCenter className="h-[22px] w-[22px] text-white" />
        ),
      },
      {
        to: '/admin/manage-subscription-plans',
        name: 'Manage Subscription Plans',
        tooltip: 'Manage subscription plans and pricing',
        icon: <Image h="22px" w="22px" src={creditCard} alt="subscription-plans-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={creditCardActive} alt="subscription-plans-icon" />
        ),
      },
      {
        to: '/account-settings',
        name: 'Settings',
        tooltip: 'Manage platform settings and configurations',
        icon: <Image h="22px" w="22px" src={settings} alt="settings-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={settingsActive} alt="settings-icon" />
        ),
      },
    ];
  }, []);

  const investorNav = useMemo(() => {
    return [
      {
        to: '/feed',
        name: 'Feed',
        tooltip: 'View and interact with posts from the community',
        icon: <MdDynamicFeed className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdDynamicFeed className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/dashboard',
        name: 'Dashboard',
        tooltip:
          'Connect with founders and track your investment opportunities',
        icon: <Image h="22px" w="22px" src={dashboard} alt="dashboard-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dashboardActive} alt="dashboard-icon" />
        ),
      },
      {
        to: '/founders',
        name: 'Founders',
        tooltip: 'Discover and connect with promising startup founders',
        icon: <Image h="22px" w="22px" src={investors} alt="founder-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={investorsActive} alt="founder-icon" />
        ),
      },
      {
        to: '/connections',
        name: 'Connections',
        tooltip: 'Manage your professional network and relationships',
        icon: (
          <Image h="22px" w="22px" src={connections} alt="connections-icon" />
        ),
        activeIcon: (
          <Image
            h="22px"
            w="22px"
            src={connectionsActive}
            alt="connections-icon"
          />
        ),
      },
      {
        to: '/deal-flow',
        name: 'Investment',
        tooltip: 'Browse investment opportunities and manage your deals',
        icon: <Image h="22px" w="22px" src={dealFlow} alt="deal-flow-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={dealFlowActive} alt="deal-flow-icon" />
        ),
      },
      {
        to: '/bookings',
        name: 'Bookings',
        tooltip: 'Schedule and manage meetings with founders and experts',
        icon: <Image h="22px" w="22px" src={investors} alt="investors-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={investorsActive} alt="investors-icon" />
        ),
      },
      {
        to: '/events',
        name: 'Events',
        tooltip: 'Discover and register for networking events',
        icon: <MdEvent className="h-[22px] w-[22px] text-gray-900" />,
        activeIcon: <MdEvent className="h-[22px] w-[22px] text-white" />,
      },
      {
        to: '/account-settings',
        name: 'Settings',
        tooltip: 'Manage your profile, preferences, and account settings',
        icon: <Image h="22px" w="22px" src={settings} alt="settings-icon" />,
        activeIcon: (
          <Image h="22px" w="22px" src={settingsActive} alt="settings-icon" />
        ),
      },
    ];
  }, []);

  const [navs, setNavs] = useState(founderNav);

  useEffect(() => {
    switch (accountType) {
      case 'admin':
        setNavs(adminNav);
        break;
      case 'sub_admin':
        setNavs(adminNav);
        break;
      case 'expert':
        setNavs(expertNav);
        break;
      case 'investor':
        setNavs(investorNav);
        break;
      default:
        setNavs(founderNav);
    }
  }, [accountType, adminNav, expertNav, investorNav, founderNav]);

  return navs;
};
export default Navs;
